import { ORGANIZATION_KINDS } from 'store/organizations';

export const LABELS = {
  [ORGANIZATION_KINDS.NURSING_HOME]: 'Neues Pflegezentrum',
  [ORGANIZATION_KINDS.OPTICIAN]: 'Neuer Optiker',
  [ORGANIZATION_KINDS.CLINIC]: 'Neuer Arzt',
};
